import React, { useState } from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import Swal from 'sweetalert2'; // Import SweetAlert
import * as XLSX from 'xlsx';
import { Backdrop, Button, Dialog, DialogContent } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress'; // Import CircularProgress from Material-UI

import apiFunctions from '../API/api';
import WhatsappApiFunctions from '../API/whatsapp';

const DownloadReport = ({ filter }) => {

  const [loading, setLoading] = useState(false);
  const Popup = () => {
    Swal.fire({
      title: 'Download Report',
      text: 'Do you want to download the report?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, download it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        handleDownload();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // User clicked "No, cancel"
        Swal.fire('Cancelled', 'The download request was cancelled.', 'info');
      }
    });
  };

  const handleDownload = async () => {
    try {
      setLoading(true);
      // Use Whatsapp ListMessage download report
      const report = await WhatsappApiFunctions.getMessageDownloadReport2(filter);
      const contacts = Array.isArray(report?.Contact) ? report.Contact : [];

      // Normalize fields for Excel
      const rows = contacts.map((c) => ({
        SentMessageDetailKey: c.SentMessageDetailKey,
        Number: c.Number,
        MessageStatus: c.MessageStatus,
        MessageStatusKey: c.MessageStatusKey,
        TemplateName: c.TemplateName,
        EventsName: c.EventsName,
        ErrorMsg: c.ErrorMsg,
        FileName: c.FileName,
        CreatedAt: c.CreatedAt,
        DeliveredAt: c.DeliveredAt,
        ReadAt: c.ReadAt,
      }));

      // Build workbook
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(rows);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Messages');

      // Generate a binary string from the workbook
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      setLoading(false);
      Swal.fire({
        icon: 'info',
        title: 'Download Started',
        text: 'Your download has started.',
        showConfirmButton: false, // Prevent the user from closing it manually
      });

      // Create a Blob from the buffer and download the file
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      a.download = 'WhatsApp_Messages.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      setLoading(false);
      console.error('Error downloading Excel:', error);
    }
  };

  return (
    <div>
      <Button onClick={Popup} variant="contained" color="primary" size="large" sx={{ height: '40px', backgroundColor: '#D24A61', color: '#ffffff', '&:hover': { backgroundColor: '#e3272c' } }}>
        <AiOutlineDownload style={{ width: 'auto', height: '22px' }} /> &#160; Download Report
      </Button>

      <Dialog open={loading} maxWidth="false">
        <DialogContent style={{ background: 'white', padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress style={{ color: '#D24A61' }} size={60} thickness={4} />{' '}
            {/* Display the loader when loading is true */}
          </div>
          <br />
          Generating Report...
        </DialogContent>
      </Dialog>
      <Backdrop open={loading} />
    </div>
  );
};
export default DownloadReport;
